import { useMutation } from "@apollo/client";

import { LoginWithOAuthMutation, LoginWithOAuthMutationVariables } from "@ctypes";
import { LOGIN_WITH_OAUTH } from "@graphql";

export const useLoginWithOAuth = () => {
  return useMutation<LoginWithOAuthMutation, LoginWithOAuthMutationVariables>(LOGIN_WITH_OAUTH);
};
